import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

/**
 * Cost pack — monthly spend, pricing model, cost center attribution.
 * Applies to every billable resource.
 */
export const networkCostFieldPack: FieldPack = {
  id: 'network-cost',
  name: 'Cost',
  description: 'Monthly spend, pricing model, cost allocation',
  version: '1.0.0',
  dependencies: ['network-base', 'network-tags'],
  fields: [
    {
      id: 'monthlySpend',
      label: 'Monthly Spend (USD)',
      type: FieldType.NUMBER,
      tags: ['cost'],
      priority: 100,
      sensitivity: 'internal',
    },
    {
      id: 'pricingModel',
      label: 'Pricing Model',
      type: FieldType.SELECT,
      tags: ['cost'],
      priority: 90,
      options: [
        { value: 'on-demand', label: 'On-Demand' },
        { value: 'reserved', label: 'Reserved (1yr)' },
        { value: 'reserved-3yr', label: 'Reserved (3yr)' },
        { value: 'spot', label: 'Spot' },
        { value: 'savings-plan', label: 'Savings Plan' },
        { value: 'free-tier', label: 'Free Tier' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'costCenter',
      label: 'Cost Center',
      type: FieldType.TEXT,
      tags: ['cost'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'budgetAlert',
      label: 'Budget Alert Threshold',
      type: FieldType.NUMBER,
      tags: ['cost'],
      priority: 80,
      sensitivity: 'internal',
    },
    {
      id: 'lastBilledAt',
      label: 'Last Billed At',
      type: FieldType.DATE,
      tags: ['cost'],
      priority: 75,
      sensitivity: 'internal',
    },
    {
      id: 'reservationUtilization',
      label: 'Reservation Utilization (%)',
      type: FieldType.NUMBER,
      tags: ['cost'],
      priority: 70,
      sensitivity: 'internal',
    },
  ],
};
